import { MCANS020CreateRequest } from "types/MCANS020/MCANS020CreateRequest";
import request from 'utils/request'

export const signIns = (data:MCANS020CreateRequest) =>
request({
    url:'/MCANS020/resister',
    method:'post',
    data:data,
})